/** @format */

import { utilityCalculateRoomURL, utilityGetRoomInfo } from '@/@ducks/room/helpers';
import { CardRoom as Card } from '@/components/ui/CardRoom';
import { CardRoomProvider } from '@/components/ui/CardRoom/context';
import useCardRoom from '@/ducks/cardRoom/hooks/useCardRoom';
import { TRoomCard } from '@/ducks/room/declarations';
import { useAppTranslation } from '@/i18n/declarations';
import { TLocale } from '@/utils/gatsby/types';
import React from 'react';

type CardRoomProps = {
  room: TRoomCard;
  hasInactiveURL?: boolean;
  index?: number;
  isCarousel?: boolean;
  selectedFilter?: string;
  currentPage?: 'city_page' | 'neighborhoods_page';
  hideTopRadius?: boolean;
  isPopup?: boolean;
  isFlexibleItem?: boolean;
};

const CardRoom: React.FC<CardRoomProps> = ({
  room,
  hasInactiveURL,
  isPopup,
  index,
  isCarousel,
  selectedFilter,
  currentPage,
  hideTopRadius = false,
  isFlexibleItem = false,
}) => {
  const { code } = room;
  const { intl } = useAppTranslation();
  const locale = intl.locale as TLocale;
  const roomURL = hasInactiveURL ? '' : utilityCalculateRoomURL({ locale, room });
  const { title } = utilityGetRoomInfo(locale, room);

  const { isLoadingAvailability, availableFrom } = useCardRoom(code, locale);

  return (
    <CardRoomProvider initialRoom={room} initialTitle={title} initialUrl={roomURL} isPopup={isPopup}>
      <Card
        index={index}
        hasInactiveURL={hasInactiveURL}
        isLoadingAvailability={isLoadingAvailability}
        availableFrom={availableFrom}
        isCarousel={isCarousel}
        selectedFilter={selectedFilter}
        currentPage={currentPage}
        hideTopRadius={hideTopRadius}
        isPopup={isPopup}
        isFlexibleItem={isFlexibleItem}
      />
    </CardRoomProvider>
  );
};

export default CardRoom;
